import { Box, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';
import { ComplementaryInfoSection } from '../types';

interface ComplementaryInfoProps {
  complementaryInfo: ComplementaryInfoSection;
}

export const ComplementaryInfo = memo(function ComplementaryInfo(
  props: ComplementaryInfoProps
) {
  const { complementaryInfo } = props;

  return (
    <Box id="inf-complementary">
      <Grid container spacing={2} marginBottom={3}>
        <Grid item xs={12}>
          <Box display="flex" alignItems="center" gap={1}>
            <GroupStatusIcon isComplete={isGroupComplete(complementaryInfo)} />
            <Typography my={2} fontWeight={600}>
              Informações Complementares
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography mb={1} color="#707070">
            Variáveis e Dados do Modelo (quantidade)
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.total_variables}
          </Typography>
          <Typography>{complementaryInfo.total_variables ?? '-'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.model_total_variables}
          </Typography>
          <Typography>
            {complementaryInfo.model_total_variables ?? '-'}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.all_data_count}
          </Typography>
          <Typography>{complementaryInfo.all_data_count ?? '-'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography variant="caption" color="text.secondary">
            {INF_STATISTIC_FIELD_LABELS.model_data_count}
          </Typography>
          <Typography>{complementaryInfo.model_data_count ?? '-'}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
});
